import { PeriodsListItem } from '../../model/PeriodsListItem';
import ServiceEndpoints from "../ServiceEndpoints"

export async function fetchPeriods(userId: string, userToken?: string) {
    return await fetch(ServiceEndpoints.FetchAllPeriods, {
        method: 'get',
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + userToken },
    }).then(async (resp) => {
        const parsedData: PeriodsListItem[] = await resp.json();
        return parsedData;
    }).catch((error) => {
        console.error(error);
        return [];
    });
}

// Function for updating an periods item
export async function UpdatePeriods(updatedperiods: PeriodsListItem, userToken?: string) {
    try {
        const response = await fetch(`${ServiceEndpoints.UpdatePeriods}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken,
            },
            // Convert the updatedperiods object to a JSON string and include it in the request body
            body: JSON.stringify(updatedperiods),
        });

        if (response.ok) {
            // If the update is successful, parse and return the response data (if any)
            return response.json();
        } else {
            // If there is an error response from the server, throw an error
            const errorMessage = await response.text();


            throw new Error(errorMessage);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}


